import "./style.css";

export default class Arrows {
  static selector = ".carousel-arrows";

  constructor(block) {
    this.block = block;
  }
}
